import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Mail, ArrowLeft, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [devLink, setDevLink] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/auth/forgot-password", { email });
      setDone(true);
      if (res.data?.dev_reset_link) setDevLink(res.data.dev_reset_link);
      toast.success(res.data?.message || "Reset-Link gesendet");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Fehler");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-8">
      <div className="w-full max-w-sm">
        <div className="label-uppercase text-prime mb-3">Passwort vergessen</div>
        <h2 className="font-display font-extrabold text-3xl tracking-tight mb-2">Passwort zurücksetzen</h2>
        <p className="text-sm text-muted-foreground mb-8">
          Geben Sie Ihre E-Mail-Adresse ein. Sie erhalten einen Link zum Zurücksetzen des Passworts.
        </p>

        {!done ? (
          <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
            <div>
              <Label className="label-uppercase text-muted-foreground">E-Mail</Label>
              <Input
                type="email" required value={email} onChange={e => setEmail(e.target.value)}
                className="h-11 mt-2" autoFocus data-testid="forgot-email"
              />
            </div>
            <Button type="submit" disabled={loading} className="w-full h-11 btn-prime gap-2" data-testid="forgot-submit">
              <Mail className="w-4 h-4" /> {loading ? "…" : "Reset-Link senden"}
            </Button>
          </form>
        ) : (
          <div className="prime-card p-5 flex flex-col items-center text-center gap-3">
            <CheckCircle2 className="w-10 h-10 text-green-600" strokeWidth={1.5} />
            <div className="font-medium">E-Mail gesendet</div>
            <p className="text-xs text-muted-foreground">
              Falls ein Konto mit dieser E-Mail existiert, wurde ein Reset-Link verschickt.
              Der Link ist 30 Minuten gültig.
            </p>
            {devLink && (
              <div className="mt-2 text-[10px] bg-amber-50 dark:bg-amber-950/30 border border-amber-200 dark:border-amber-700 rounded p-2 w-full break-all">
                <div className="text-amber-700 dark:text-amber-300 font-bold mb-1">DEV-LINK (keine E-Mail konfiguriert)</div>
                <a href={devLink} className="text-prime underline">{devLink}</a>
              </div>
            )}
          </div>
        )}

        <Link to="/login" className="mt-6 inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground">
          <ArrowLeft className="w-3 h-3" /> Zurück zum Login
        </Link>
      </div>
    </div>
  );
}
